module.exports = __webpack_public_path__ + "static/media/reply-icon.f4cc1cd6.svg";